import { axios } from '@/utils/request'

export function getCompanyDetail (id) {
  return axios({
    url: '/company/detail?id=' + id,
    method: 'get'
  })
}

export function listCompanyPage (data) {
  return axios({
    url: '/company/page',
    method: 'post'
  })
}
export function createCompany (form) {
  return axios({
    url: '/company/create',
    method: 'post',
    data: form
  })
}

export function updateCompany (form) {
  return axios({
    url: '/company/update',
    method: 'post',
    data: form
  })
}
export function deleteCompany (id) {
  return axios({
    url: '/company/delete?id=' + id,
    method: 'post'
  })
}

export function listCompanyUserPage (data) {
  return axios({
    url: '/userV2/pageV2?corpId=' + data.corpId + '&pageNumber=' + data.pageNumber + '&pageSize=' + data.pageSize,
    method: 'get'
  })
}

export function createCompanyUser (data) {
  return axios({
    url: '/userV2/createV2',
    method: 'post',
    data: data
  })
}
export function updateCompanyUser (data) {
  return axios({
    url: '/userV2/updateV2',
    method: 'put',
    data: data
  })
}
export function deleteCompanyUser (id) {
  return axios({
    url: '/userV2/deleteV2?id=' + id,
    method: 'delete'
  })
}
export function getCompanyUserDetail (id) {
  return axios({
    url: '/userV2/detailV2?id=' + id,
    method: 'get'
  })
}
export function enableCompanyUser (id, enabled) {
  return axios({
    url: '/userV2/setEnabledV2?id=' + id + '&enabled=' + enabled,
    method: 'get'
  })
}
export function resetCompanyUserPassword (id, password) {
  return axios({
    url: '/userV2/restorePasswordV2?id=' + id + '&password=' + password,
    method: 'post'
  })
}
export function getStatistics (data) {
  return axios({
    url: '/company/statistics',
    method: 'post',
    data: data
  })
}
